import React from 'react';

const generateArrModal = ({ title }) => ({
  title,
  body: (
    <div>
      <p>
        The arrival time is the universal coordinated time of the arrival of the maximum trough wave at the location of the effects given in Day, Hour and Minutes.
      </p>
    </div>
  ),
});

export const RuMaxTroughDayModal = generateArrModal({ title: 'Maximum Trough Time - Day' });
export const RuMaxTroughHourModal = generateArrModal({ title: 'Maximum Trough Time - Hour' });
export const RuMaxTroughMinuteModal = generateArrModal({ title: 'Maximum Wave Trough - Minutes' });
